import axios from "axios"
import { EOpenFactsCategory } from "enum";
import { ListBeautyProductsDto } from "types/dto";
import { ApiService } from "./apiService";

// Maps our category option to the OBF category tag to filter search.pl by.
const CATEGORY_TAGS: Partial<Record<EOpenFactsCategory, string>> = {
    [EOpenFactsCategory.MAKEUP]: 'makeup',
};

export const getBeautyProducts = async (dto: ListBeautyProductsDto) => {
    const categoryTag = CATEGORY_TAGS[dto.category ?? EOpenFactsCategory.ALL];
    const categoryParam = categoryTag ? `&tagtype_0=categories&tag_contains_0=contains&tag_0=${categoryTag}` : '';
    const { data } = await axios.get(`https://world.openbeautyfacts.org/cgi/search.pl?action=process&json=1&page_size=${dto.size}&page=${dto.page}&fields=code,images${categoryParam}`);
    return data;
}

export interface ImportOpenFactsDto {
    page: number;
    size: number;
    category?: EOpenFactsCategory;
}

export type ImportProductEvent = {
    type: 'product';
    barcode: string;
    status: 'suggested' | 'skipped' | 'failed';
    reason?: string;
};

export type ImportDoneEvent = {
    type: 'done';
    processed: number;
    suggested: number;
    skipped: number;
    failed: number;
};

export type ImportEvent = ImportProductEvent | ImportDoneEvent;

export const importOpenFactsStream = async (
    dto: ImportOpenFactsDto,
    onEvent: (event: ImportEvent) => void,
    signal?: AbortSignal,
): Promise<void> => {
    const user = JSON.parse(localStorage.getItem('@user') || 'null');
    const token = user?.apiToken;

    const categoryParam = dto.category ? `&category=${dto.category}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/open-facts/import?page=${dto.page}&size=${dto.size}${categoryParam}`;
    const response = await fetch(url, {
        method: 'GET',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        signal,
    });

    if (!response.ok || !response.body) throw new Error('Import request failed');

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let eventType = 'message';
    let dataLines: string[] = [];

    const flush = () => {
        if (dataLines.length === 0) return;
        const data = dataLines.join('\n');
        const type = eventType;
        eventType = 'message';
        dataLines = [];
        if (type === 'error') throw new Error(data || 'Import failed');
        onEvent(JSON.parse(data));
    };

    const processLine = (line: string) => {
        if (line === '') flush();
        else if (line.startsWith('event: ')) eventType = line.slice(7).trim();
        else if (line.startsWith('data: ')) dataLines.push(line.slice(6));
    };

    while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop()!;
        for (const line of lines) processLine(line);
    }
    processLine('');
}